<template>
  <div>
    <b-modal
      id="reviewmodal"
      title="Review"
      class="review-modal-wrapper"
      no-stacking
    >
      <div slot="modal-header" class="w-100 text-center review-modal-header">
        <h4>Review</h4>
        <span>{{ courseName }}</span>
      </div>
      <b-form data-vv-scope="review">
        <div class="review-modal-rating-section">
          <star-rating
            v-model="review.rating"
            v-bind="starattribs"
          ></star-rating>
        </div>
        <div
          style="text-align: center; margin-top: -1em; margin-bottom: 1em;"
          id="rating-feedback"
          v-if="ratingInvalid && !(review.rating !== 0)"
        >
          <small style="color: #dc3545;font-size: .6em">
            Rating must be provided
          </small>
        </div>

        <b-form-input
          id="review_title"
          placeholder="Title.."
          v-model="review.review_title"
          v-validate="'required|min:3|max:20'"
          name="Review Title"
          :class="{ 'is-invalid': errors.has('review.Review Title') }"
        >
        </b-form-input>
        <b-form-invalid-feedback id="review-title-feedback">
          <small>{{ errors.first("review.Review Title") }}</small>
        </b-form-invalid-feedback>
        <b-form-textarea
          id="textarea"
          v-model="review.review_text"
          placeholder="Enter something..."
          rows="3"
          max-rows="6"
          v-validate="'required|min:3'"
          name="Review Text"
          :class="{ 'is-invalid': errors.has('review.Review Text') }"
        ></b-form-textarea>
        <b-form-invalid-feedback id="review-text-feedback">
          <small>{{ errors.first("review.Review Text") }}</small>
        </b-form-invalid-feedback>
      </b-form>
      <div slot="modal-footer" class="w-100">
        <b-button
          variant="primary"
          size="sm"
          class="float-right"
          @click="action('review')"
          type="submit"
        >
          Submit
        </b-button>
      </div>
    </b-modal>

    <b-modal
      id="reviewthanks"
      title="Second Modal"
      hide-footer
      hide-header
      size="sm"
    >
      <div class="review-thanks-wrapper">
        <img src="/img/icons/png/thankslike.png" alt="" />
        <p class="">Thank You</p>
        <span>For your feedback</span>
        <b-button pill size="sm" @click="$bvModal.hide('reviewthanks')"
          >close</b-button
        >
      </div>
    </b-modal>
    <b-modal
      id="reviewFailed"
      title="Second Modal"
      hide-footer
      hide-header
      size="sm"
    >
      <div class="review-thanks-wrapper">
        <img src="/img/sorryicon.jpeg" alt="" />
        <p class="">Sorry</p>
        <span>We are not able send your feedback</span>
        <b-button pill size="sm" @click="$bvModal.hide('reviewFailed')"
          >close</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import { customerApi } from "../../services/customerApi";

export default {
  name: "ReviewModal",
  data() {
    return {
      show: false,
      starattribs: {
        starSize: 30,
        showRating: false,
        activeColor: "#faa30c"
      },
      ratingInvalid: false,
      showReviewError: false
    };
  },
  methods: {
    action(scope) {
      this.$validator.validateAll(scope).then(result => {
        if (result && this.review.rating !== 0) {
          this.showReviewError = false;
          this.reviewCourse();
        } else {
          this.showReviewError = true;
          this.ratingInvalid = true;
        }
      });
    },
    reviewCourse() {
      if (this.isTeacher) {
        const reviewData = {
          teacher_id: this.courseId,
          review_text: this.review.review_text,
          review_title: this.review.review_title,
          rating: this.review.rating
        };
        customerApi
          .reviewTeacher(reviewData)
          .then(() => {
            this.$bvModal.show("reviewthanks");
          })
          .catch(() => {
            this.$bvModal.show("reviewFailed");
          });
      } else {
        const reviewData = {
          course_id: this.courseId,
          review_text: this.review.review_text,
          review_title: this.review.review_title,
          rating: this.review.rating
        };
        customerApi
          .reviewCourse(reviewData)
          .then(() => {
            this.$bvModal.show("reviewthanks");
          })
          .catch(() => {
            this.$bvModal.show("reviewFailed");
          });
      }
    }
  },
  props: {
    courseId: String,
    courseName: String,
    isTeacher: Boolean,
    review: Object
  }
};
</script>

<style scoped></style>
